document.addEventListener('DOMContentLoaded', () => {
  if (document.body.dataset.geminiHeaderInitialized) return;
  document.body.dataset.geminiHeaderInitialized = 'true';

  const headerWrapper = document.getElementById('gemini-header-wrapper');
  const header = document.getElementById('gemini-header-main');
  const hamburger = document.getElementById('gemini-hamburger');
  const navMenu = document.getElementById('gemini-nav-menu');

  if (!headerWrapper || !header) return;

  const isOverlayPage = !headerWrapper.classList.contains('gemini-header-wrapper--solid');

  if (hamburger && navMenu) {
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('active');
      navMenu.classList.toggle('active');
    });
  }

  let lastScrollTop = 0;
  let ticking = false;

  const scrollHandler = () => {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        // Check scroll direction
        if (scrollPosition > lastScrollTop && scrollPosition > 50) {
          // Scrolling Down: Apply solid/small state
          header.classList.add('small');
          if (isOverlayPage) {
            headerWrapper.classList.add('gemini-header-wrapper--solid');
          }
        } else if (scrollPosition < lastScrollTop) {
          // Scrolling Up: Revert to floating/transparent state
          header.classList.remove('small');
          if (isOverlayPage) {
            headerWrapper.classList.remove('gemini-header-wrapper--solid');
          }
        }

        // Always ensure it's in the initial floating state at the very top
        if (scrollPosition <= 10) {
           header.classList.remove('small');
           if (isOverlayPage) {
              headerWrapper.classList.remove('gemini-header-wrapper--solid');
           }
        }

        lastScrollTop = scrollPosition <= 0 ? 0 : scrollPosition;
        ticking = false;
      });
      ticking = true;
    }
  };

  // Attach listener to all potential scroll containers for robustness
  window.addEventListener('scroll', scrollHandler, { passive: true });
  document.addEventListener('scroll', scrollHandler, { passive: true });
  document.body.addEventListener('scroll', scrollHandler, { passive: true });

  // Handle mobile submenu toggles
  const dropdowns = navMenu.querySelectorAll('.has-dropdown');
  dropdowns.forEach(dropdown => {
    const link = dropdown.querySelector('a');
    link.addEventListener('click', (event) => {
      // Only apply this logic on mobile
      if (window.innerWidth <= 990) {
        const isOpen = dropdown.classList.contains('open');

        // If the submenu is NOT open, prevent the page from reloading and open it.
        if (!isOpen) {
          event.preventDefault();
          // Optional: close any other submenus that might be open
          dropdowns.forEach(d => d.classList.remove('open'));
          // Open the current submenu
          dropdown.classList.add('open');
        }
        // If the submenu is ALREADY open, the second tap will work as a normal link.
      }
    });
  });
});
